// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import AccountSettingsState from "@insite/client-framework/Store/Pages/AccountSettings/AccountSettingsState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type xAccountSettingType = Readonly<{
    phone?: string;
    phoneErrorMessage?: string;
}>;

export const initialPhoneState: xAccountSettingType = {
    phone: "",
    phoneErrorMessage: "",
};

const reducer = {
    "xAccountSettings/UpdatePhoneNumber": (
        draft: Draft<xAccountSettingType>,
        action: { phone?: string; phoneErrorMessage?: string },
    ) => {
        if (typeof action.phone !== "undefined") {
            draft.phone = action.phone;
            draft.phoneErrorMessage = action.phoneErrorMessage;
        }
    },
};

const xAccountSetting = createTypedReducerWithImmer(initialPhoneState, reducer);

(reducers as any).xAccountSetting = xAccountSetting;

export type xAccountSettingState = {
    xAccountSetting: xAccountSettingType;
} & ApplicationState;
